import { TableCell, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import Button from "src/Components/Button";
import Table from "src/Components/Table";
import useRequest from "src/Hooks/useRequest";
import {
  GetShekarMetricEvents,
  IShekarOrderMetricEvent,
} from "src/Interfaces/shekarMetricEvents";
import { packetErrorHandler } from "src/Utils/requestUtils";

interface IProps {
  algorithmOrderId: number;
  conditionId: number;
  getEvents: GetShekarMetricEvents;
}

const getEventValue = (
  event: IShekarOrderMetricEvent,
  key: keyof IShekarOrderMetricEvent,
) => event[key] || "-";

const ShekarMetricEventsModalContent = ({
  algorithmOrderId,
  conditionId,
  getEvents,
}: IProps) => {
  const [windowLen, setWindowLen] = useState(5);
  const eventsRequest = useRequest(
    (abortSignal) =>
      getEvents(algorithmOrderId, conditionId, windowLen, {
        signal: abortSignal,
      }),
    packetErrorHandler,
  );

  useEffect(() => {
    eventsRequest.fetchData();
    // Fetch once when the modal opens; refresh is handled by the search button.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const events = eventsRequest.response?.events || [];
  const eventRows = events.length ? (
    events.map((event, index) => (
      <TableRow key={`${event.counterName}-${index}`}>
        <TableCell>{event.counterName}</TableCell>
        <TableCell>{event.increase}</TableCell>
        <TableCell>{getEventValue(event, "result")}</TableCell>
        <TableCell>{getEventValue(event, "reason")}</TableCell>
        <TableCell>{getEventValue(event, "stage")}</TableCell>
        <TableCell>{getEventValue(event, "side")}</TableCell>
        <TableCell>{getEventValue(event, "instrumentType")}</TableCell>
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={7} className="!text-center">
        {eventsRequest.loading ? "در حال دریافت" : "موردی یافت نشد"}
      </TableCell>
    </TableRow>
  );

  return (
    <div className="w-[min(1100px,90vw)] max-h-[80vh] overflow-auto flex flex-col gap-4">
      <div className="flex flex-row flex-wrap justify-start items-end gap-3">
        <div className="text-xs bg-slate-100 rounded px-2 py-1">
          algorithm_order_id: {algorithmOrderId}
        </div>
        <div className="text-xs bg-slate-100 rounded px-2 py-1">
          condition_id: {conditionId}
        </div>
        <label className="flex flex-col gap-1 text-xs">
          windowLen
          <input
            className="border border-slate-300 rounded px-2 py-1 w-24"
            min={1}
            max={1440}
            type="number"
            value={windowLen}
            onChange={(e) => setWindowLen(Number(e.target.value || 5))}
          />
        </label>
        <Button
          onClick={() => eventsRequest.fetchData()}
          text="جستجو"
          variant="contained"
          className="table-btn"
          loading={eventsRequest.loading}
        />
      </div>
      <Table
        header={
          <>
            <TableCell>counter</TableCell>
            <TableCell>increase</TableCell>
            <TableCell>result</TableCell>
            <TableCell>reason</TableCell>
            <TableCell>stage</TableCell>
            <TableCell>side</TableCell>
            <TableCell>instrument</TableCell>
          </>
        }
        body={<>{eventRows}</>}
      />
    </div>
  );
};

export default ShekarMetricEventsModalContent;
